<template>
    <v-container grid-list-xl>
        <v-layout row wrap pt-4>
            <v-flex xs12>
                    <h1>Federal Election {{ year }}</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-4>
            <v-flex xs12>
                    <h2>Results by State</h2>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex v-for="section in sections"
                    :key="section.id"
                    v-bind="{ 'md6': true }">
                <v-card>
                    <v-list>
                        <div v-for="(item, index) in section.items" :key="item.abbrev">
                            <v-divider v-if="index !== 0" :key="index"></v-divider>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <router-link :to="{ name: 'SenateResultByState', params: { state: item.abbrev } }">
                                            {{ item.name }}
                                        </router-link>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </div>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>    
    </v-container>
</template>
<script>
export default {
    props: ['year'],
    data() {
        return {
            sections: [
                {
                    id: 1,
                    items: [
                        { name: 'New South Wales', abbrev: 'NSW' },
                        { name: 'Victoria', abbrev: 'VIC' },
                        { name: 'Queensland', abbrev: 'QLD' },
                        { name: 'Western Australia', abbrev: 'WA' }                
                    ]
                },
                {
                    id: 2,
                    items: [
                        { name: 'South Australia', abbrev: 'SA' },
                        { name: 'Tasmania', abbrev: 'TAS' },
                        { name: 'Australian Capital Territory', abbrev: 'ACT' },
                        { name: 'Northern Territory', abbrev: 'NT' }
                    ]
                }
            ]
        }
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
    }
</style>